import { bl_applet_role_pricing_scheme_link_RowClass } from '../../dbschema/bl_applet_role_pricing_scheme_link.model';
import {BaseContainerModel} from '../base-container.model';

export class ClientSidePermissionPricingSchemeRoleLinkContainerModel extends BaseContainerModel {
    bl_applet_role_pricing_scheme_link: bl_applet_role_pricing_scheme_link_RowClass = new bl_applet_role_pricing_scheme_link_RowClass();
}